// Bilingual translations: Greek (primary) + English (secondary)
export const translations = {
  el: {
    nav: {
      home: "Αρχική",
      shop: "Κατάστημα",
      categories: "Κατηγορίες",
      careers: "Καριέρα",
      about: "Σχετικά",
      contact: "Επικοινωνία",
      account: "Λογαριασμός",
      login: "Σύνδεση",
      register: "Εγγραφή",
      logout: "Αποσύνδεση",
      cart: "Καλάθι",
      admin: "Διαχείριση",
      search: "Αναζήτηση προϊόντων...",
    },
    home: {
      heroOverline: "Premium Pet Boutique · Est. 2026",
      heroTitle: "Amazy-ng Προϊόντα\nΓια Amazing Κατοικίδια",
      heroSubtitle: "Επιμελημένα προϊόντα πολυτελείας για τους πιο σημαντικούς συντρόφους της ζωής μας. Δωρεάν αποστολή άνω των 50€.",
      shopNow: "Αγοράστε τώρα",
      exploreCollection: "Δείτε τη συλλογή",
      featuredOverline: "Επιλεγμένα από τη συλλογή",
      featuredTitle: "Επιλογές της εβδομάδας",
      categoriesOverline: "Όλες οι κατηγορίες",
      categoriesTitle: "Για κάθε είδος συντρόφου",
      valuesTitle: "Γιατί Amazypet",
      v1Title: "Χειροδιάλεκτη Επιλογή",
      v1Desc: "Κάθε προϊόν επιλέγεται με προσοχή από κορυφαίους ευρωπαϊκούς οίκους.",
      v2Title: "Δωρεάν Αποστολή 50€+",
      v2Desc: "Δωρεάν αποστολή σε όλη την Ελλάδα για παραγγελίες άνω των 50€.",
      v3Title: "Ασφαλείς Πληρωμές",
      v3Desc: "Stripe, PayPal, αντικαταβολή και τραπεζική κατάθεση.",
      newsletterTitle: "Γίνετε μέλος της Amazypet Society",
      newsletterDesc: "Αποκλειστικές προσφορές και νέες αφίξεις, πριν από όλους.",
      newsletterCta: "Εγγραφή",
    },
    product: {
      addToCart: "Προσθήκη στο καλάθι",
      buyNow: "Άμεση Αγορά",
      outOfStock: "Εξαντλήθηκε",
      inStock: "Διαθέσιμο",
      description: "Περιγραφή",
      details: "Στοιχεία",
      sku: "Κωδικός",
      brand: "Brand",
      category: "Κατηγορία",
      source: "Πηγή",
      sale: "Έκπτωση",
      from: "από",
      free_shipping: "Δωρεάν αποστολή από 50€",
      quantity: "Ποσότητα",
    },
    shop: {
      title: "Όλα τα προϊόντα",
      filters: "Φίλτρα",
      allCategories: "Όλες οι κατηγορίες",
      sortBy: "Ταξινόμηση",
      sortPriceAsc: "Τιμή: Χαμηλή σε υψηλή",
      sortPriceDesc: "Τιμή: Υψηλή σε χαμηλή",
      sortName: "Όνομα Α-Ω",
      noResults: "Δεν βρέθηκαν προϊόντα.",
      results: "αποτελέσματα",
    },
    cart: {
      title: "Το καλάθι σας",
      empty: "Το καλάθι σας είναι άδειο.",
      emptyCta: "Συνεχίστε τις αγορές",
      subtotal: "Υποσύνολο",
      shipping: "Μεταφορικά",
      free: "Δωρεάν",
      total: "Σύνολο",
      checkout: "Ολοκλήρωση παραγγελίας",
      remove: "Αφαίρεση",
      continueShopping: "Συνέχεια αγορών",
    },
    checkout: {
      title: "Ολοκλήρωση Παραγγελίας",
      contact: "Στοιχεία επικοινωνίας",
      shipping: "Διεύθυνση αποστολής",
      payment: "Μέθοδος πληρωμής",
      review: "Ανασκόπηση",
      fullName: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      street: "Διεύθυνση",
      city: "Πόλη",
      postalCode: "ΤΚ",
      country: "Χώρα",
      notes: "Σχόλια (προαιρετικό)",
      payStripe: "Κάρτα (Viva)",
      payStripeDesc: "Visa, Mastercard, Apple Pay, Google Pay — Ασφαλής Smart Checkout της Viva.",
      payCard: "Κάρτα (Viva)",
      payCardDesc: "Visa, Mastercard, Apple Pay, Google Pay — Ασφαλής Smart Checkout της Viva.",
      payPaypal: "PayPal",
      payPaypalDesc: "Πληρωμή μέσω του λογαριασμού σας PayPal.",
      payBank: "Τραπεζική Κατάθεση",
      payBankDesc: "Παραλαβή τραπεζικών στοιχείων μετά την παραγγελία.",
      placeOrder: "Καταχώρηση παραγγελίας",
      back: "Πίσω",
      next: "Επόμενο",
      orderSummary: "Σύνοψη παραγγελίας",
      couponCode: "Κωδικός κουπονιού",
      couponPlaceholder: "Εισάγετε κωδικό",
      applyCoupon: "Εφαρμογή",
      couponApplied: "Κουπόνι ενεργοποιημένο",
      couponInvalid: "Μη έγκυρο κουπόνι",
      removeCoupon: "Αφαίρεση",
      discount: "Έκπτωση",
    },
    success: {
      title: "Ευχαριστούμε για την παραγγελία σας!",
      processing: "Επεξεργασία πληρωμής...",
      processingDesc: "Παρακαλούμε περιμένετε όσο η Viva επιβεβαιώνει την πληρωμή σας.",
      timeoutDesc: "Δεν λάβαμε επιβεβαίωση εγκαίρως. Ελέγξτε το email σας ή τη σελίδα παραγγελιών σας.",
      paid: "Η πληρωμή σας ολοκληρώθηκε επιτυχώς.",
      pending: "Η παραγγελία σας καταχωρήθηκε.",
      orderNumber: "Αριθμός παραγγελίας",
      continueShopping: "Συνέχεια αγορών",
      timeout: "Δεν ήταν δυνατή η επιβεβαίωση της πληρωμής. Επικοινωνήστε μαζί μας.",
      bankDetails: "Στοιχεία τραπεζικής κατάθεσης",
      iban: "IBAN",
      beneficiary: "Δικαιούχος",
      bank: "Τράπεζα",
      reference: "Αιτιολογία",
    },
    auth: {
      loginTitle: "Σύνδεση στο λογαριασμό σας",
      registerTitle: "Δημιουργία λογαριασμού",
      email: "Email",
      password: "Κωδικός",
      name: "Ονοματεπώνυμο",
      submitLogin: "Σύνδεση",
      submitRegister: "Εγγραφή",
      googleLogin: "Συνέχεια με Google",
      orWith: "ή",
      noAccount: "Δεν έχετε λογαριασμό;",
      hasAccount: "Έχετε ήδη λογαριασμό;",
      createOne: "Δημιουργήστε έναν",
      signIn: "Συνδεθείτε",
      loginError: "Λάθος στοιχεία σύνδεσης.",
      registerError: "Σφάλμα εγγραφής.",
    },
    account: {
      welcome: "Καλώς ήρθατε",
      myOrders: "Οι παραγγελίες μου",
      noOrders: "Δεν έχετε ακόμα παραγγελίες.",
      orderNumber: "Παραγγελία",
      date: "Ημερομηνία",
      status: "Κατάσταση",
      total: "Σύνολο",
      viewOrder: "Προβολή",
    },
    reviews: {
      title: "Αξιολογήσεις πελατών",
      section: "Αξιολογήσεις πελατών",
      writeReview: "Γράψτε αξιολόγηση",
      cancel: "Ακύρωση",
      yourRating: "Η βαθμολογία σας",
      yourName: "Το όνομά σας",
      namePlaceholder: "π.χ. Μαρία Π.",
      titleInput: "Τίτλος",
      comment: "Σχόλιο",
      submit: "Δημοσίευση",
      submitSuccess: "Η αξιολόγηση δημοσιεύτηκε.",
      commentRequired: "Το σχόλιο πρέπει να έχει τουλάχιστον 3 χαρακτήρες.",
      noReviews: "Καμία αξιολόγηση ακόμα",
      review: "αξιολόγηση",
      reviews: "αξιολογήσεις",
      verifiedBuyer: "Επαληθευμένος αγοραστής",
      beTheFirst: "Γίνετε ο πρώτος που θα αξιολογήσει αυτό το προϊόν.",
    },
    loyalty: {
      title: "Πρόγραμμα Πιστότητας",
      yourPoints: "Οι πόντοι σας",
      tier: "Επίπεδο",
      nextTier: "Επόμενο επίπεδο",
      pointsToNext: "πόντοι για",
      howItWorks: "Πώς λειτουργεί",
      earn: "Κερδίστε 1 πόντο για κάθε 1€",
      redeem: "Εξαργυρώστε 20 πόντους = 1€ έκπτωση",
      minRedeem: "Ελάχιστη εξαργύρωση: 100 πόντοι",
      history: "Ιστορικό πόντων",
      noHistory: "Δεν υπάρχει ακόμα ιστορικό.",
      earned: "Κέρδισε",
      redeemed: "Εξαργύρωσε",
      tiers: "Επίπεδα",
      points: "πόντοι",
      redeemAtCheckout: "Εξαργύρωση πόντων",
      availablePoints: "Διαθέσιμοι πόντοι",
      redeemAmount: "Πόντοι προς εξαργύρωση",
      redeemValue: "Αξία",
      applyRedeem: "Εφαρμογή",
      removeRedeem: "Αφαίρεση",
      redeemed_label: "Εξαργύρωση πόντων",
    },
    wishlist: {
      title: "Λίστα Επιθυμιών",
      empty: "Η λίστα επιθυμιών σας είναι άδεια. Αποθηκεύστε προϊόντα κάνοντας κλικ στην καρδιά.",
      exploreShop: "Εξερευνήστε το κατάστημα",
      item: "προϊόν",
      items: "προϊόντα",
      addToWishlist: "Προσθήκη στη Λίστα",
      removeFromWishlist: "Αφαίρεση από τη Λίστα",
    },
    careers: {
      heroOverline: "Καριέρα στην Amazypet",
      heroTitle: "Γίνετε μέλος της οικογένειάς μας",
      heroSubtitle: "Αναζητούμε ταλέντα που μοιράζονται την αγάπη μας για τα κατοικίδια. Δείτε τις διαθέσιμες θέσεις και κάντε αίτηση σήμερα.",
      openPositions: "Διαθέσιμες θέσεις",
      noJobs: "Δεν υπάρχουν αυτή τη στιγμή διαθέσιμες θέσεις. Επανέλθετε σύντομα!",
      location: "Τοποθεσία",
      type: "Τύπος",
      department: "Τμήμα",
      salary: "Μισθός",
      viewDetails: "Δείτε περισσότερα",
      applyNow: "Κάντε αίτηση",
      backToList: "← Πίσω στις θέσεις",
      description: "Περιγραφή",
      requirements: "Απαιτήσεις",
      applyTitle: "Αίτηση εργασίας",
      fullName: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      cvUrl: "Σύνδεσμος Βιογραφικού (URL)",
      coverLetter: "Συνοδευτική επιστολή",
      submitApplication: "Αποστολή αίτησης",
      applicationSuccess: "Η αίτησή σας υποβλήθηκε επιτυχώς. Θα επικοινωνήσουμε σύντομα.",
      employment: {
        full_time: "Πλήρης απασχόληση",
        part_time: "Μερική απασχόληση",
        internship: "Πρακτική άσκηση",
        freelance: "Freelance",
      },
    },
    admin: {
      title: "Διαχείριση Καταστήματος",
      products: "Προϊόντα",
      orders: "Παραγγελίες",
      settings: "Ρυθμίσεις",
      integrations: "Ενσωματώσεις",
      categories: "Κατηγορίες",
      backup: "Αντίγραφο Ασφαλείας",
      notifsTitle: "Ενημερωτικά Email Παραγγελιών",
      notifsDesc: "Όρισε έως 2 διευθύνσεις email που θα λαμβάνουν ενημέρωση για κάθε νέα πληρωμένη παραγγελία. Μπορείς να απενεργοποιήσεις προσωρινά οποιαδήποτε από τις δύο.",
      notifSlot: "Email Παραλήπτη",
      notifEnabled: "Ενεργό",
      notifDisabled: "Ανενεργό",
      notifWillReceive: "Θα λαμβάνει ενημέρωση για κάθε νέα παραγγελία.",
      notifWontReceive: "Δεν θα λαμβάνει emails μέχρι να ενεργοποιηθεί ξανά.",
      notifsSaved: "Οι ρυθμίσεις αποθηκεύτηκαν",
      backupTitle: "Αντίγραφο Ασφαλείας & Επαναφορά",
      backupDesc: "Κατέβασε ολόκληρη τη βάση δεδομένων σε αρχείο JSON ή επανέφερε τα δεδομένα σου από προηγούμενο αντίγραφο. Πάντα κράτα ένα τοπικό αντίγραφο πριν από κάθε deployment.",
      downloadBackup: "Λήψη Αντιγράφου",
      downloadBackupDesc: "Εξάγει προϊόντα, κατηγορίες, παραγγελίες, χρήστες, κουπόνια, reviews, ρυθμίσεις και integrations σε ένα αρχείο .json.",
      restoreBackup: "Επαναφορά Δεδομένων",
      restoreBackupDesc: "Φόρτωσε προηγούμενο αρχείο .json για να επαναφέρεις τα δεδομένα.",
      restoreMode: "Τρόπος επαναφοράς",
      modeMerge: "Συγχώνευση (Merge) — Ενημερώνει/προσθέτει χωρίς διαγραφή",
      modeReplace: "Αντικατάσταση (Replace) — Διαγράφει και ξανα-εισάγει τα πάντα",
      uploadBackup: "Επιλογή αρχείου & Επαναφορά",
      backupDownloaded: "Το αντίγραφο κατέβηκε επιτυχώς",
      restoreDone: "Η επαναφορά ολοκληρώθηκε",
      restoreConfirm: "Σίγουρα θες να επαναφέρεις τη βάση από αυτό το αρχείο; Η ενέργεια αυτή μπορεί να αντικαταστήσει υπάρχοντα δεδομένα.",
      restoreSummary: "Σύνοψη επαναφοράς",
      maintenanceMode: "Λειτουργία Συντήρησης",
      maintenanceDesc: "Όταν είναι ενεργοποιημένη, μόνο οι admins βλέπουν το site. Όλοι οι άλλοι επισκέπτες βλέπουν μια σελίδα συντήρησης.",
      maintenanceOn: "Ενεργή",
      maintenanceOff: "Ανενεργή",
      enable: "Ενεργοποίηση",
      disable: "Απενεργοποίηση",
      addProduct: "Νέο Προϊόν",
      editProduct: "Επεξεργασία προϊόντος",
      name: "Όνομα",
      priceEur: "Τιμή (€)",
      salePrice: "Τιμή Έκπτωσης",
      markupPercent: "Markup (%)",
      stock: "Stock",
      category: "Κατηγορία",
      source: "Πηγή (custom/shopify/bigbuy)",
      save: "Αποθήκευση",
      cancel: "Ακύρωση",
      delete: "Διαγραφή",
      edit: "Επεξεργασία",
      featured: "Προβεβλημένο",
      images: "Εικόνες (URLs χωριστά με κόμμα)",
      descEl: "Περιγραφή (Ελ.)",
      descEn: "Περιγραφή (En)",
      nameEl: "Όνομα (Ελ.)",
      nameEn: "Όνομα (En)",
      brand: "Brand",
      sku: "SKU",
      jobs: "Καριέρα",
      applications: "Αιτήσεις",
      coupons: "Κουπόνια",
      addCoupon: "Νέο κουπόνι",
      editCoupon: "Επεξεργασία κουπονιού",
      code: "Κωδικός",
      type: "Τύπος",
      typePercentage: "Ποσοστιαία",
      typeFixed: "Σταθερό ποσό",
      typeFreeShipping: "Δωρεάν μεταφορικά",
      value: "Τιμή",
      minSubtotal: "Ελάχιστο υποσύνολο",
      maxUses: "Μέγιστες χρήσεις",
      expiresAt: "Λήγει στις",
      uses: "Χρήσεις",
      description: "Περιγραφή",
      addJob: "Νέα θέση",
      editJob: "Επεξεργασία θέσης",
      jobTitle: "Τίτλος θέσης",
      location: "Τοποθεσία",
      employmentType: "Τύπος απασχόλησης",
      department: "Τμήμα",
      salaryRange: "Εύρος μισθού",
      applyEmail: "Email αιτήσεων",
      active: "Ενεργή",
      requirementsEl: "Απαιτήσεις (Ελ.)",
      requirementsEn: "Απαιτήσεις (En)",
    },
    footer: {
      tagline: "Amazy-ng Προϊόντα Για Amazing Κατοικίδια",
      headquarters: "Έδρα καταστήματος",
      notShowroom: "(αποκλειστικά διεύθυνση επιχείρησης — δεν είναι showroom)",
      shop: "Κατάστημα",
      about: "Σχετικά με εμάς",
      contact: "Επικοινωνία",
      shipping: "Αποστολή & Επιστροφές",
      terms: "Όροι Χρήσης",
      privacy: "Πολιτική Απορρήτου",
      followUs: "Ακολουθήστε μας",
      copy: "© 2026 Amazypet. All rights reserved.",
    },
    maintenance: {
      title: "Είμαστε υπό συντήρηση",
      message: "Το κατάστημα είναι προσωρινά εκτός λειτουργίας για αναβάθμιση. Επιστρέφουμε σύντομα με νέα προϊόντα και βελτιώσεις. Ευχαριστούμε για την υπομονή σας.",
      adminLogin: "Είσοδος Διαχειριστή",
    },
  },
  en: {
    nav: {
      home: "Home", shop: "Shop", categories: "Categories", careers: "Careers", about: "About",
      contact: "Contact", account: "Account", login: "Sign In", register: "Sign Up",
      logout: "Sign Out", cart: "Cart", admin: "Admin", search: "Search products...",
    },
    home: {
      heroOverline: "Premium Pet Boutique · Est. 2026",
      heroTitle: "Amazy-ng Products\nFor Amazing Pets",
      heroSubtitle: "Curated luxury essentials for the most important companions in our lives. Free shipping over €50.",
      shopNow: "Shop now", exploreCollection: "Explore the collection",
      featuredOverline: "Curated from the collection",
      featuredTitle: "This week's selection",
      categoriesOverline: "All categories",
      categoriesTitle: "For every kind of companion",
      valuesTitle: "Why Amazypet",
      v1Title: "Hand-curated Selection",
      v1Desc: "Every product is carefully chosen from leading European houses.",
      v2Title: "Free Shipping over €50",
      v2Desc: "Free shipping throughout Greece for orders over €50.",
      v3Title: "Secure Payments",
      v3Desc: "Stripe, PayPal, cash on delivery & bank transfer.",
      newsletterTitle: "Join the Amazypet Society",
      newsletterDesc: "Exclusive offers and new arrivals, before everyone else.",
      newsletterCta: "Subscribe",
    },
    product: {
      addToCart: "Add to cart", buyNow: "Buy now",
      outOfStock: "Out of stock", inStock: "In stock",
      description: "Description", details: "Details", sku: "SKU",
      brand: "Brand", category: "Category", source: "Source",
      sale: "Sale", from: "from", free_shipping: "Free shipping over €50",
      quantity: "Quantity",
    },
    shop: {
      title: "All products", filters: "Filters", allCategories: "All categories",
      sortBy: "Sort", sortPriceAsc: "Price: low to high", sortPriceDesc: "Price: high to low",
      sortName: "Name A-Z", noResults: "No products found.", results: "results",
    },
    cart: {
      title: "Your cart", empty: "Your cart is empty.", emptyCta: "Continue shopping",
      subtotal: "Subtotal", shipping: "Shipping", free: "Free", total: "Total",
      checkout: "Checkout", remove: "Remove", continueShopping: "Continue shopping",
    },
    checkout: {
      title: "Checkout", contact: "Contact details", shipping: "Shipping address",
      payment: "Payment method", review: "Review",
      fullName: "Full name", email: "Email", phone: "Phone", street: "Street address",
      city: "City", postalCode: "Postal code", country: "Country",
      notes: "Notes (optional)",
      payStripe: "Card (Viva)", payStripeDesc: "Visa, Mastercard, Apple Pay, Google Pay — Viva Smart Checkout.",
      payCard: "Card (Viva)", payCardDesc: "Visa, Mastercard, Apple Pay, Google Pay — Viva Smart Checkout.",
      payPaypal: "PayPal", payPaypalDesc: "Pay via your PayPal account.",
      payBank: "Bank Transfer", payBankDesc: "Receive bank details after order.",
      placeOrder: "Place order", back: "Back", next: "Next",
      orderSummary: "Order summary",
      couponCode: "Coupon code", couponPlaceholder: "Enter code",
      applyCoupon: "Apply", couponApplied: "Coupon applied",
      couponInvalid: "Invalid coupon", removeCoupon: "Remove",
      discount: "Discount",
    },
    success: {
      title: "Thank you for your order!", processing: "Processing payment...",
      processingDesc: "Please wait while Viva confirms your payment.",
      timeoutDesc: "We didn't receive confirmation in time. Please check your email or your orders page.",
      paid: "Your payment was successful.", pending: "Your order has been placed.",
      orderNumber: "Order number", continueShopping: "Continue shopping",
      timeout: "Unable to confirm payment. Please contact us.",
      bankDetails: "Bank transfer details", iban: "IBAN",
      beneficiary: "Beneficiary", reference: "Reference",
      bank: "Bank",
    },
    auth: {
      loginTitle: "Sign in to your account", registerTitle: "Create your account",
      email: "Email", password: "Password", name: "Full name",
      submitLogin: "Sign in", submitRegister: "Sign up",
      googleLogin: "Continue with Google", orWith: "or",
      noAccount: "Don't have an account?", hasAccount: "Already have an account?",
      createOne: "Create one", signIn: "Sign in",
      loginError: "Invalid credentials.", registerError: "Registration error.",
    },
    account: {
      welcome: "Welcome", myOrders: "My orders", noOrders: "You don't have any orders yet.",
      orderNumber: "Order", date: "Date", status: "Status", total: "Total",
      viewOrder: "View",
    },
    reviews: {
      section: "Customer reviews",
      title: "What our customers say",
      writeReview: "Write a review",
      cancel: "Cancel",
      yourRating: "Your rating",
      yourName: "Your name",
      namePlaceholder: "e.g. Maria P.",
      titleInput: "Title",
      comment: "Comment",
      submit: "Publish",
      submitSuccess: "Review published.",
      commentRequired: "Comment must be at least 3 characters.",
      noReviews: "No reviews yet",
      review: "review",
      reviews: "reviews",
      verifiedBuyer: "Verified buyer",
      beTheFirst: "Be the first to review this product.",
    },
    loyalty: {
      title: "Loyalty Program",
      yourPoints: "Your points",
      tier: "Tier",
      nextTier: "Next tier",
      pointsToNext: "points to",
      howItWorks: "How it works",
      earn: "Earn 1 point per €1 spent",
      redeem: "Redeem 20 points = €1 discount",
      minRedeem: "Minimum redemption: 100 points",
      history: "Points history",
      noHistory: "No history yet.",
      earned: "Earned",
      redeemed: "Redeemed",
      tiers: "Tiers",
      points: "points",
      redeemAtCheckout: "Redeem points",
      availablePoints: "Available points",
      redeemAmount: "Points to redeem",
      redeemValue: "Value",
      applyRedeem: "Apply",
      removeRedeem: "Remove",
      redeemed_label: "Points redemption",
    },
    wishlist: {
      title: "Wishlist",
      empty: "Your wishlist is empty. Save products by clicking the heart icon.",
      exploreShop: "Explore the shop",
      item: "item",
      items: "items",
      addToWishlist: "Add to Wishlist",
      removeFromWishlist: "Remove from Wishlist",
    },
    careers: {
      heroOverline: "Careers at Amazypet",
      heroTitle: "Join our family",
      heroSubtitle: "We're looking for talented people who share our love of pets. Browse open roles and apply today.",
      openPositions: "Open positions",
      noJobs: "No open positions at the moment. Check back soon!",
      location: "Location",
      type: "Type",
      department: "Department",
      salary: "Salary",
      viewDetails: "View details",
      applyNow: "Apply now",
      backToList: "← Back to listings",
      description: "Description",
      requirements: "Requirements",
      applyTitle: "Job application",
      fullName: "Full name",
      email: "Email",
      phone: "Phone",
      cvUrl: "CV link (URL)",
      coverLetter: "Cover letter",
      submitApplication: "Submit application",
      applicationSuccess: "Your application has been submitted. We'll be in touch soon.",
      employment: {
        full_time: "Full time",
        part_time: "Part time",
        internship: "Internship",
        freelance: "Freelance",
      },
    },
    admin: {
      title: "Store Management", products: "Products", orders: "Orders",
      settings: "Settings",
      integrations: "Integrations",
      categories: "Categories",
      backup: "Backup",
      notifsTitle: "Order Notification Emails",
      notifsDesc: "Configure up to 2 email addresses that will receive a notification for each new paid order. You can temporarily disable either one.",
      notifSlot: "Recipient Email",
      notifEnabled: "Enabled",
      notifDisabled: "Disabled",
      notifWillReceive: "Will receive notifications for every new order.",
      notifWontReceive: "Won't receive any emails until re-enabled.",
      notifsSaved: "Settings saved",
      backupTitle: "Backup & Restore",
      backupDesc: "Download a JSON snapshot of the entire database or restore from a previous backup. Always keep a local copy before each deployment.",
      downloadBackup: "Download Backup",
      downloadBackupDesc: "Exports products, categories, orders, users, coupons, reviews, settings and integrations into one .json file.",
      restoreBackup: "Restore Data",
      restoreBackupDesc: "Upload a previously saved .json backup to restore data.",
      restoreMode: "Restore mode",
      modeMerge: "Merge — upsert without deleting existing data",
      modeReplace: "Replace — wipe collections then re-insert",
      uploadBackup: "Choose file & Restore",
      backupDownloaded: "Backup downloaded successfully",
      restoreDone: "Restore completed",
      restoreConfirm: "Are you sure you want to restore from this file? This may overwrite existing data.",
      restoreSummary: "Restore summary",
      maintenanceMode: "Maintenance Mode",
      maintenanceDesc: "When enabled, only admins can view the site. All other visitors see a maintenance page.",
      maintenanceOn: "Enabled",
      maintenanceOff: "Disabled",
      enable: "Enable",
      disable: "Disable",
      addProduct: "New product", editProduct: "Edit product",
      name: "Name", priceEur: "Price (€)", salePrice: "Sale price", markupPercent: "Markup (%)",
      stock: "Stock", category: "Category", source: "Source (custom/shopify/bigbuy)",
      save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit",
      featured: "Featured", images: "Images (URLs separated by comma)",
      descEl: "Description (GR)", descEn: "Description (EN)",
      nameEl: "Name (GR)", nameEn: "Name (EN)",
      brand: "Brand", sku: "SKU",
      jobs: "Careers", applications: "Applications",
      coupons: "Coupons",
      addCoupon: "New coupon", editCoupon: "Edit coupon",
      code: "Code", type: "Type",
      typePercentage: "Percentage", typeFixed: "Fixed amount", typeFreeShipping: "Free shipping",
      value: "Value", minSubtotal: "Min subtotal",
      maxUses: "Max uses", expiresAt: "Expires at",
      uses: "Uses", description: "Description",
      addJob: "New position", editJob: "Edit position",
      jobTitle: "Job title", location: "Location",
      employmentType: "Employment type", department: "Department",
      salaryRange: "Salary range", applyEmail: "Application email",
      active: "Active",
      requirementsEl: "Requirements (GR)", requirementsEn: "Requirements (EN)",
    },
    footer: {
      tagline: "Amazy-ng Products For Amazing Pets",
      headquarters: "Business address",
      notShowroom: "(registered office only — not a public showroom)",
      shop: "Shop", about: "About us", contact: "Contact",
      shipping: "Shipping & Returns", terms: "Terms of use", privacy: "Privacy policy",
      followUs: "Follow us", copy: "© 2026 Amazypet. All rights reserved.",
    },
    maintenance: {
      title: "We're under maintenance",
      message: "The store is temporarily offline for upgrades. We'll be back soon with new products and improvements. Thanks for your patience.",
      adminLogin: "Admin sign in",
    },
  },
};
